import { render, staticRenderFns } from "./TableSalesModal.vue?vue&type=template&id=3b5bb882"
import script from "./TableSalesModal.vue?vue&type=script&lang=js"
export * from "./TableSalesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports